import { jsx as _jsx } from "react/jsx-runtime";
import { Grid, GridItem, Typography } from '@coolblue-development/freddy';
import { getStyleQuery } from '../../../../utils/index.js';
export const Introduction = ({ content, isBasicHeader, useContainerQuery }) => {
    const { queryType } = getStyleQuery(useContainerQuery);
    return (_jsx(Grid, { children: _jsx(GridItem, { column: isBasicHeader
                ? {
                    values: { xs: 'span 12', lg: 'span 8' },
                    type: queryType,
                }
                : 'span 12', children: _jsx(Typography, { variant: "intro", m: 0, children: content }) }) }));
};
//# sourceMappingURL=Introduction.js.map